/**
 * Chat bubbles show the tagged section(s) as a label above the message, so
 * the tag must not be repeated inside the message text. The teacher composer
 * writes "@Section Title" into the text and older student turns carry the
 * quoted "Section Title" — both are removed for display only; the text sent
 * to the AI is unchanged.
 */
const escapeRegExp = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/**
 * @param {string} text  the message as typed/stored
 * @param {string[]} titles  titles of the sections shown in the bubble's tag label
 * @param {{ all?: boolean }} [opts]  `all` — the whole session (@all) was tagged
 * @returns {string}
 */
export function stripSectionMentions(text, titles, { all = false } = {}) {
  let out = typeof text === 'string' ? text : '';
  const names = (Array.isArray(titles) ? titles : []).filter((t) => typeof t === 'string' && t.trim());
  for (const title of names) {
    const t = escapeRegExp(title.trim());
    out = out.replace(new RegExp(`@${t}(?![\\w])`, 'gi'), ' ').replace(new RegExp(`"${t}"`, 'gi'), ' ');
  }
  if (all) out = out.replace(/@all(?![\w])/gi, ' ');
  return out.replace(/[ \t]{2,}/g, ' ').replace(/ +([?.!,;:])/g, '$1').trim();
}
